export default "__VITE_ASSET__40a9e2b5__"